// Bundle Product Code Added

window.onload = function () {
  initial()
  bundleCartObserver()
  function initial() {
    if (document.querySelector(".bundle-product [data-add-to-cart]")) {
      document.querySelector(
        ".bundle-product [data-add-to-cart]"
      ).style.display = "inline-block"
      document
        .querySelector(".bundle-product [data-add-to-cart]")
        .addEventListener("click", function (e) {
          e.preventDefault()
          var bundle = document.querySelector(".product-form__variants")
          var variant_id = bundle.value
          var checked = document
            .querySelector(
              `.custom_kit_section-container[data-id='${variant_id}']`
            )
            .querySelectorAll('[name="bundle_product"]:checked')
          var qty = document.querySelector("#quantity").value
          var data = []
          var data = {
            items: [],
          }
          checked.forEach(function (item) {
            var id = item.value * 1
            data["items"].push({
              id: id,
              quantity: qty,
              properties: {
                _bundle_product_: "true",
                _bundle_id_: bundle.value,
              },
            })
          })
          // //Add the bundle product
          // data["items"].push({
          //   id: bundle.value,
          //   quantity: qty,
          //   properties: {
          //     _bundle_id_: bundle.value,
          //     _main_bundle_product: "true",
          //   },
          // });
          addBundleToCart(data)
        })
    }
  }
  function addBundleToCart(data) {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        window.location.href = "/cart"
        return
      })
      .catch((error) => {
        console.error("Error:", error)
      })
  }

  function bundleCartObserver() {
    document.querySelector("body").addEventListener("click", function (e) {
      if (
        e.target.classList.contains("cart-drawer-item__remove") ||
        e.target.closest(".cart-drawer-item__remove")
      ) {
        e.preventDefault()
        // console.log('remove');
        var target_id = e.target
          .closest("[data-product-id]")
          .getAttribute("data-product-id")
        if (isMainBundleProduct(e.target)) {
          setTimeout(() => {
            jQuery.getJSON("/cart.js", function (cart) {
              var data = getBundleProductData(target_id, cart.items, 0)
              updateBundleProducts(data)
            })
          }, 500)
        }
        return
      }

      if (
        e.target.classList.contains("cart-drawer-item__quantity_button") ||
        e.target.closest(".cart-drawer-item__quantity_button")
      ) {
        e.preventDefault()
        var target_id = e.target
          .closest("[data-product-id]")
          .getAttribute("data-product-id")

        var quantity = e.target.getAttribute("data-cart-quantity")
        if (isMainBundleProduct(e.target)) {
          setTimeout(() => {
            jQuery.getJSON("/cart.js", function (cart) {
              var data = getBundleProductData(target_id, cart.items, quantity)
              updateBundleProducts(data)
            })
          }, 500)
        }
      }
      function isMainBundleProduct(target) {
        if (
          target
            .closest(".cart-drawer-item")
            .querySelector(".cart-drawer-item__property--_main_bundle_product")
        ) {
          return true
        } else {
          return false
        }
      }
      function getBundleProductData(target, cart, quantity) {
        var data = {
          updates: [],
        }
        cart.forEach((item) => {
          if (item.properties && item.properties._bundle_id_ === target) {
            data.updates.push(quantity)
          } else {
            data.updates.push(item.quantity)
          }
        })
        return data
      }
    })
  }

  function updateBundleProducts(data) {
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        location.reload()

        return response.json()
      })
      .then((cart) => {
        console.log(cart)
      })
      .catch((error) => {
        console.error("Error:", error)
      })
  }
}
